import { createLocalStorageStateHook } from "use-local-storage-state";
import { TLoginResponseData } from '../types/loginTypes';

export default createLocalStorageStateHook<TLoginResponseData>("SessionInfo");
